// extracted by mini-css-extract-plugin
export default {"font-semibold":"Error404_font-semibold__HffMq","error404":"Error404_error404__INPi4"};